import { listFiles, uploadFile, deleteFolder, deleteFile } from "./helper";

export default class StorageEngine {
  constructor(nodeName) {
    this.nodeName = nodeName;
  }

  listAll = async () => {
    return await listFiles(this.nodeName);
  };

  listPaginated = async (pageNumber) => {};

  upload = async (file, folder = "") => {
    return await uploadFile(this.nodeName + (folder ? `/${folder}` : ``), file);
  };

  clearFolder = async (folder) => {
    return await deleteFolder(this.nodeName + "/" + folder);
  };

  delete = async (file, folder) => {
    return await deleteFile(this.nodeName + `/${folder}`, file);
  };
}
